export default function TextMessage({ message }) {
  try {
    const messageContent = message.message_content;
    if (!messageContent) return <></>;

    // Replace all occurrences of \n or \r\n with <br/>
    const formattedContent = messageContent
      .replace(/\r\n/g, '<br/>')
      .replace(/\n/g, '<br/>')
      .replace(/\r/g, '<br/>');

    return (
      <div className="text-sm">
        <span dangerouslySetInnerHTML={{ __html: formattedContent }} />
      </div>
    );
  } catch (error) {
    console.error('Error formatting message:', error);
    return <></>;
  }
}
